// extracted by mini-css-extract-plugin
export default {"FAQ_section":"YourFaqs_FAQ_section__tdZQf","addLink":"YourFaqs_addLink__tBiHQ","conversationText":"YourFaqs_conversationText__kjYkl","inputTextare":"YourFaqs_inputTextare__xpNFZ"};